export function SelectedFilterCount({ count }: { count: number }) {
  return (
    <div className="bg-primary text-primary-foreground rounded-full min-w-5 h-5 leading-5 text-center">
      <span className="text-xs">{count}</span>
    </div>
  );
}
